import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=2dbf3abf&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=2dbf3abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf3abf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbf3abf')) {
      api.createRecord('2dbf3abf', component.options)
    } else {
      api.reload('2dbf3abf', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=2dbf3abf&scoped=true&", function () {
      api.rerender('2dbf3abf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/forms/UserProfile.vue"
export default component.exports